import { AddDomainInput } from "@/components/Deploy/CustomDomainsDialog";
import api from "../api";
import { API_URL } from "../constants";
import {
  CreateDeployFormData,
  UpdateDeploySettingsFormData,
} from "../validations";
import { GetDeployLogsParams } from "./types";

export const createDeploy = async (data: CreateDeployFormData) => {
  return api.post(`${API_URL}/v1/deploy`, {
    ...data,
  });
};

export const getDeploy = async (id: string) => {
  return api.get(`${API_URL}/v1/deploy/${id}`);
};

export const getDeployEnvVars = async (id: string) => {
  return api.get(`${API_URL}/v1/deploy/${id}/env-var`);
};

export const getDeployCount = async () => {
  return api.get(`${API_URL}/v1/deploy/count`);
};

export const getRecentDeploys = async () => {
  return api.get(`${API_URL}/v1/deploy/recent`);
};

export const getSampleApplications = async () => {
  return api.get(`${API_URL}/v1/deploy/samples`);
};

export const createSampleDeploy = async (data: {
  sampleSlug: string;
  env: string;
  region: string;
}) => {
  return api.post(`${API_URL}/v1/deploy/sample`, data);
};

export const getDeploys = async (
  limit: number,
  offset: number,
  searchTerm: string,
) => {
  return api.get(
    `${API_URL}/v1/deploy?${new URLSearchParams({
      limit: String(limit),
      offset: String(offset),
      search: searchTerm,
    })}`,
  );
};

export const addDomain = async (data: AddDomainInput): Promise<any> => {
  const body = {
    name: data.domain,
  };
  return api.post(`${API_URL}/v1/deploy/${data.deployId}/domain`, body, {});
};

export const removeDomain = async (data: AddDomainInput): Promise<any> => {
  const body = {
    name: data.domain,
  };
  return api.post(`${API_URL}/v1/deploy/${data.deployId}/domain`, body, {});
};

export const reDeploy = async (data: UpdateDeploySettingsFormData) => {
  return api.post(`${API_URL}/v1/deploy/${data.id}/redeploy`, {
    ...data,
  });
};
export const deleteDeploy = async (id: string) => {
  return api.delete(`${API_URL}/v1/deploy/${id}`);
};

export const getDeployRuntimeLogs = async (
  deployId: string,
  params: GetDeployLogsParams,
) => {
  const query = new URLSearchParams({
    startTime: String(params.startTime),
    endTime: String(params.endTime),
    limit: String(params.limit ?? 200),
    offset: String(params.offset ?? 0),
  });

  if (params.level) {
    query.set("level", params.level);
  }

  if (params.search) {
    query.set("search", params.search);
  }

  return api.get(`${API_URL}/v1/logs/deploy/${deployId}?${query.toString()}`);
};
